import { Cell } from '../grid/Cell'
import { BaseModal } from './BaseModal'
import { Key } from '../keyboard/Key'
import { getStoredIsHighContrastMode } from '../../lib/localStorage'

type Props = {
  isOpen: boolean
  handleClose: () => void
}

export const InfoModal = ({ isOpen, handleClose }: Props) => {
  const isHighContrast = getStoredIsHighContrastMode()
  return (
    <BaseModal
      title="Žaidimo taisyklės"
      isOpen={isOpen}
      handleClose={handleClose}
    >
      <p className="text-sm text-gray-500 dark:text-gray-300">
        Atspėkite lietuvišką žodį iš 5 raidžių.
      </p>

      <p className="text-sm text-gray-500 dark:text-gray-300">
        Po spėjimo raidžių spalva parodys ar priartėjote prie tikslo.
      </p>

      <p className="text-sm text-gray-500 dark:text-gray-300 text-center">
        Raidė{' '}
        <span
          className={`inline-block px-1 py-0.5 text-white font-bold rounded whitespace-nowrap ${
            isHighContrast ? 'bg-orange-500' : 'bg-green-500'
          }`}
        >
          Ž
        </span>{' '}
        yra pirmame žodyje teisingoje vietoje.
      </p>

      <p className="text-sm text-gray-500 dark:text-gray-300 text-center">
        Raidė{' '}
        <span
          className={`inline-block px-1 py-0.5 text-white font-bold rounded whitespace-nowrap ${
            isHighContrast ? 'bg-cyan-500' : 'bg-yellow-500'
          }`}
        >
          N
        </span>{' '}
        yra pirmame žodyje, bet ne toje vietoje.
      </p>

      <p className="text-sm text-gray-500 dark:text-gray-300 text-center">
        Žaidimo tikslas – atspėti visas raides teisingai.
      </p>

      <div className="flex justify-center mb-1 mt-4">
        <Cell
          isRevealing={true}
          isCompleted={true}
          value="Ž"
          status="correct"
        />
        <Cell isRevealing={true} isCompleted={true} status="absent" value="I" />
        <Cell
          isRevealing={true}
          isCompleted={true}
          status="present"
          value="N"
        />
        <Cell isRevealing={true} isCompleted={true} status="absent" value="I" />
        <Cell isRevealing={true} isCompleted={true} status="absent" value="A" />
      </div>
      <p className="text-sm text-gray-500 dark:text-gray-300">...</p>
      <div className="flex justify-center mb-1 mt-4">
        <Cell
          isRevealing={true}
          isCompleted={true}
          status="correct"
          value="Ž"
        />
        <Cell
          isRevealing={true}
          isCompleted={true}
          status="correct"
          value="E"
        />
        <Cell
          isRevealing={true}
          isCompleted={true}
          status="correct"
          value="M"
        />
        <Cell
          isRevealing={true}
          isCompleted={true}
          status="correct"
          value="Y"
        />
        <Cell
          isRevealing={true}
          isCompleted={true}
          status="correct"
          value="N"
        />
      </div>
      <div className="mt-3 flex justify-center mb-1">
        <Key width={140} value={'SUPRATAU'} onClick={handleClose} />
      </div>

      <p className="mt-6 italic text-sm text-gray-500 dark:text-gray-300">
        {' '}
        <a
          href="https://github.com/cwackerfuss/react-wordle"
          className="underline font-bold"
        >
          Tai yra atvirojo kodo žaidimo Wordle versija
        </a>{' '}
        <p className="text-sm text-gray-500 dark:text-gray-300">
          Parengė T. Liubinas
        </p>
      </p>
    </BaseModal>
  )
}
